import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt,  FaUserShield, FaMinus, FaPlus, FaChartLine,  FaFileInvoiceDollar, FaBrain, FaProjectDiagram, FaClipboardCheck, FaRobot, FaHospitalUser, FaClipboardList,FaMoneyBillWave, FaMoneyCheckAlt ,FaFileInvoice, FaUserSecret, FaSearchDollar, FaCalculator, FaGlobe, FaChartBar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Revenue = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Revenue Cycle Management Integration</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, We provide AI-powered healthcare data analytics solutions to help hospitals, clinics, and health tech companies process, analyze, and visualize medical data for better decision-making and patient care.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Revenue Cycle Management (RCM) Integration",
        description: "Streamline billing, claims processing, and financial workflows.",
        icon: FaMoneyCheckAlt
    },
    {
        title: "Seamless EHR Interoperability",
        description: "Ensure smooth data exchange between EHR, practice management, and payment systems.",
        icon: FaFileInvoiceDollar
    },
    {
        title: "Maximize Revenue & Reduce Administrative Burden",
        description: "Enhance financial efficiency while minimizing operational complexities.",
        icon: FaHospitalUser
    }, {
        title: "Compliance & Security Assurance",
        description: "Ensure HIPAA-compliant data handling and secure healthcare transactions.",
        icon: FaShieldAlt
    }
];



const services = [

    { icon: FaFileInvoiceDollar, title: "End-to-End RCM Integration", description: "Connect EHR, billing, and insurance systems for a unified financial workflow." },
    { icon: FaRobot, title: "Automated Claims Processing", description: "Optimize insurance claims submission, verification, and adjudication." },
    { icon: FaMoneyCheckAlt, title: "Payment & Reimbursement Solutions", description: "Enhance payment processing, patient invoicing, and reimbursement tracking." },
    { icon: FaHospitalUser, title: "Medical Coding & Charge Capture", description: "Improve CPT, ICD-10, and HCPCS code accuracy to reduce claim denials." },
    { icon: FaClipboardCheck, title: "Eligibility & Benefits Verification", description: "Automate real-time insurance verification to reduce billing errors." },
    { icon: FaUserShield, title: "Denial Management & Appeals", description: "Identify, analyze, and resolve claim denials efficiently." },
    { icon: FaShieldAlt, title: "Compliance & Security", description: "Ensure HIPAA, CMS, and payer compliance with secure data handling." }
];

const whyChooseUs = [
    {
        title: "Real-Time Financial Analytics",
        description: "Gain insights into revenue performance, claims trends, and financial metrics.",
        icon: FaChartLine
    },
    {
        title: "AI-Powered Billing Optimization",
        description: "Leverage machine learning to predict denials and optimize reimbursement rates.",
        icon: FaBrain
    },
    {
        title: "Seamless Multi-Payer Integration",
        description: "Connect effortlessly with multiple insurance providers for faster claims approval.",
        icon: FaGlobe
    },
    {
        title: "Automated Patient Cost Estimation",
        description: "Provide accurate out-of-pocket cost estimates to improve patient financial transparency.",
        icon: FaCalculator
    },
    {
        title: "Smart Claim Auditing",
        description: "Detect potential errors before submission to reduce claim rejections.",
        icon: FaSearchDollar
    },
    {
        title: "Custom Payment Plans",
        description: "Enable flexible patient payment options with automated reminders and tracking.",
        icon: FaMoneyBillWave
    },
    {
        title: "Integrated Prior Authorization",
        description: "Streamline pre-approval processes to minimize delays in patient care.",
        icon: FaClipboardList
    },
    {
        title: "Enhanced Fraud Detection",
        description: "Utilize AI-driven fraud analysis to identify suspicious billing patterns.",
        icon: FaUserSecret
    }
];

const List = [
    
        {
            "title": "Intelligent Medical Billing",
            "description": "Leverage automation to streamline claims submission, invoice processing, and payment reconciliation. Reduce errors, accelerate reimbursements, and optimize revenue cycle management with AI-driven billing workflows.",
            "icon": "FaFileInvoice"
        },
        {
            "title": "Optimized RCM Workflows",
            "description": "Enhance revenue cycle efficiency with automated pre-authorizations, real-time eligibility verification, and seamless charge capture. Minimize manual tasks and improve claim accuracy to reduce denials.",
            "icon": "FaProjectDiagram"
        },
        {
            "title": "Advanced Financial Insights",
            "description": "Gain real-time visibility into revenue trends, cash flow, and key performance indicators with advanced analytics. Monitor financial health, identify bottlenecks, and make data-driven decisions to maximize profitability.",
            "icon": "FaChartBar"
        },
        {
            "title": "AI-Powered Revenue Protection",
            "description": "Utilize machine learning and predictive analytics to identify potential claim denials, fraud risks, and revenue leakage. Proactively address issues before they impact cash flow and ensure maximum reimbursement.",
            "icon": "FaShieldAlt"
        },
        {
            "title": "Seamless Payer & Provider Integration",
            "description": "Enable real-time data exchange between healthcare providers, insurance payers, Medicare, and Medicaid. Improve claims accuracy, reduce processing time, and ensure compliance with industry standards.",
            "icon": "FaExchangeAlt"
        }
    ]
    



export default Revenue;
